module.exports = __webpack_public_path__ + "img/fruct21_demo.78c09ad5.jpg";